import { render, staticRenderFns } from "./useregister.vue?vue&type=template&id=a4ba69ec&scoped=true"
import script from "./useregister.vue?vue&type=script&lang=js"
export * from "./useregister.vue?vue&type=script&lang=js"
import style0 from "./useregister.vue?vue&type=style&index=0&id=a4ba69ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ba69ec",
  null
  
)

export default component.exports